import './index.css';

import React from 'react';
import { createRoot } from 'react-dom/client';

import { backendClientInterceptor } from './api/clients';
import { App } from './App';

backendClientInterceptor();

const container = document.getElementById('root') || document.createElement('div');
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
